import { useSelector } from 'react-redux';
import { getSessionStorage } from '@utils/windowUtil';
import { getValueFromSearchParam } from '@utils/history';

function useProjectId() {
  const projectIdFromRedux = useSelector((state) => state.common.currentId);
  const projectIdFromStorage = getSessionStorage('currentId');
  const { projectId: projectIdFromSearch } =
    getValueFromSearchParam('projectId');

  const projectId =
    projectIdFromSearch || projectIdFromRedux || projectIdFromStorage;

  return projectId;
}

export default useProjectId;
